import type { ReactNode } from 'react'

import { createContext, useMemo, useState } from 'react'

export type ContextValues = {
  isAuthenticated: boolean | undefined
  idToken: string | null
  setIdToken: (value: string | null) => void
  setIsAuthenticated: (isAuthenticated: boolean) => void
}

export type AuthContextType = ContextValues

export const AuthContext = createContext<AuthContextType>({
  isAuthenticated: undefined,
  idToken: '',
  setIdToken: () => { },
  setIsAuthenticated: () => { },
})

export function AuthContextProvider({ children }: { children: ReactNode }) {
  const [idToken, setIdToken] = useState<string | null>(null)
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | undefined>(undefined)

  const values = {
    isAuthenticated,
    idToken,
  }

  const providerValues = useMemo(
    () => ({
      ...values,
      setIsAuthenticated,
      setIdToken,
    }),
    [values, setIsAuthenticated, setIdToken],
  )

  return (<AuthContext.Provider value={providerValues} > {children} </AuthContext.Provider>)
}

export default AuthContextProvider
